// src/icons/MeditationIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function MeditationIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M12.0833 2.08333C12.0833 3.23393 11.1506 4.16667 10 4.16667C8.84941 4.16667 7.91667 3.23393 7.91667 2.08333C7.91667 0.93274 8.84941 0 10 0C11.1506 0 12.0833 0.93274 12.0833 2.08333Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M13.3333 5.83333C13.6261 5.83333 13.8973 5.98692 14.0479 6.23792L15.0914 7.97707C15.8444 9.23209 17.2007 10 18.6643 10H19.1667C19.6269 10 20 10.3731 20 10.8333C20 11.2936 19.6269 11.6667 19.1667 11.6667H18.6643C16.6153 11.6667 14.7165 10.5916 13.6622 8.83456L12.8615 7.5H8.33334V14.1667C8.33334 14.6269 7.96024 15 7.5 15H2.19951C1.90523 15 1.66667 15.2386 1.66667 15.5328C1.66667 15.7893 1.8493 16.0093 2.10131 16.0566L4.32024 16.4726C4.7726 16.5574 5.07055 16.9929 4.98573 17.4452C4.90091 17.8976 4.46545 18.1955 4.0131 18.1107L1.79417 17.6947C0.753859 17.4996 3.17891e-06 16.5913 3.17891e-06 15.5328C3.17891e-06 14.3181 0.984756 13.3333 2.19951 13.3333H6.66667V8.28637L6.33776 8.83456C5.28354 10.5916 3.38475 11.6667 1.33571 11.6667H0.833333C0.373096 11.6667 0 11.2936 0 10.8333C0 10.3731 0.373096 10 0.833333 10H1.33571C2.79931 10 4.15559 9.23209 4.9086 7.97707L5.95209 6.23792C6.10269 5.98692 6.37395 5.83333 6.66667 5.83333H13.3333Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M10 19.2333L5.9869 19.9857C5.53455 20.0705 5.09909 19.7726 5.01427 19.3202C4.92945 18.8679 5.2274 18.4324 5.67976 18.3476L9.82776 17.5699C9.84025 17.5672 9.85283 17.5649 9.86549 17.5628L17.8987 16.0566C18.1507 16.0093 18.3333 15.7893 18.3333 15.5328C18.3333 15.2386 18.0948 15 17.8005 15H12.5C12.0398 15 11.6667 14.6269 11.6667 14.1667V11.25C11.6667 10.7898 12.0398 10.4167 12.5 10.4167C12.9602 10.4167 13.3333 10.7898 13.3333 11.25V13.3333H17.8005C19.0152 13.3333 20 14.3181 20 15.5328C20 16.5913 19.2461 17.4996 18.2058 17.6947L14.4782 18.3936C14.8395 18.5388 15.0602 18.923 14.9857 19.3202C14.9009 19.7726 14.4654 20.0705 14.0131 19.9857L10 19.2333Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  MeditationIcon
};
//# sourceMappingURL=MeditationIcon.mjs.map